import { render, staticRenderFns } from "./publiccase-manage.vue?vue&type=template&id=86ad167a"
import script from "./publiccase-manage.vue?vue&type=script&lang=ts"
export * from "./publiccase-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports